import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'
import { useNavigate } from 'react-router-dom';
import HomeReviews from '../HomeReviews/HomeReviews';
import useReviews from '../hooks/useReviews';
import './Home.css'

const Home = () => {
    const [reviews, setReviews] = useReviews()
    const navigate = useNavigate()
    const handler = () => {
        const path = `/reviews`;
        navigate(path)
    }

    return (
            <Container className='banner'>
                <Row className='banner'>
                    <Col>
                        <div className='banner-text'>
                            <h4>MacBook Air</h4>
                            <h1>Power. Its in the Air.</h1>
                            <p>Our thinnest, lightest notebook, completely transformed by the Apple M1 chip. CPU speeds up to 3.5x faster. GPU speeds up to 5x faster. An advanced Neural Engine for up to 9x faster machine learning. The longest battery life ever in a MacBook Air. And a silent, fanless design. This much power has never been this ready to go.</p>
                        </div>
                     </Col>
                     <Col>
                        <Image className='img-fluid' src="https://cdn.mos.cms.futurecdn.net/evXUJyFJY9mjyYT4LQFAWo.jpg" alt="" />
                     </Col>
                </Row>
                <Row>
                <h1 className='text-center'>Coustomer Reviews.</h1>
                    <Col className='d-flex mt-4'>
                        {
                            reviews.map(review=><HomeReviews
                            key={review.id}
                            review= {review}
                            ></HomeReviews>).slice(0,3)
                        }
                    </Col>
                </Row>
                <Row className='mt-4 justify-content-center'>
                    <Button onClick={handler} className='w-25' variant="danger">All Coustomer Reviews</Button>
                </Row>
                
            </Container>
    );
};

export default Home;